import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzNpday70 } from './pages'

type TIdToPageMapWoofzNpday70 = Record<PageIdWoofzNpday70, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_NPDAY_70: TIdToPageMapWoofzNpday70 = {
  [PageId.SUBSCRIPTIONS_NPDAY_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_70/pages/subscriptions/SubscriptionNpday70'
      ).then((m) => ({
        default: m.SubscriptionsNpday70,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_70/pages/subscriptions/SubscriptionNpday70'
      ),
  },
  [PageId.CHAT_UPSELL_NPDAY_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_70/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_70/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_NPDAY_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_70/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_npday/woofz_npday_70/pages/upsell/Upsell'),
  },
  [PageIdWoofzNpday70.DOWNLOAD_NPDAY_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_70/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_70/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzNpday70.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
